<template>
  <div class="block xs-12">
    <!-- Name -->
    <core-form-input
      componentName="j-base-input-text"
      name="nameFormat"
      :label="$t('name')"
      v-validate="'required'"
      v-model="form.name"
      :validationErrors="errors"
    />

    <!-- Name -->
    <core-form-input
      class="mt6"
      componentName="j-base-input-text"
      name="source"
      :label="$t('source')"
      v-model="form.source"
    />

    <!-- isActive -->
    <core-form-input
      class="mt6"
      componentName="j-base-toggle"
      name="isActive"
      :label="$t('active_referral')"
      v-model="form.isActive"
    />

    <!-- Actions slot for buttons -->
    <slot name="actions" :onSubmit="onSubmit"></slot>
  </div>
</template>

<script>
/**
 * This component is responsible for rendering of fields for creation and update of Organizations
 */

import CoreFormInput from "@/modules/core/components/CoreFormInput"

export default {
	components: { CoreFormInput },

	props: {
		data: {
			type: Object,
			required: false,
			default: () => ({
				name: null,
				source: null,
				photoUrl: null,
				isActive: true
			})
		}
	},

	data() {
		return {
			form: {
				name: null,
				source: null,
				photoUrl: null,
				isActive: true
			}
		}
	},

	methods: {
		/**
		 * When form is valid this method emits input event with this.form as payload
		 */
		async onSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.$emit("input", this.form)
		}
	},

	watch: {
		data: {
			handler() {
				this.form = { ...this.data }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
